import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const UPDATE_AD_UNIT_UNFILLED_RECOVERY: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation updateAdUnitUnfilledRecovery($input: UpdateAdUnitUnfilledRecoveryInput!) {
    updateAdUnitUnfilledRecovery(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
